export const PAGE_HEADER_HEIGHT = 100
export const PAGE_CONTENT_ID = 'page-content'
export const ADMIN_BANNER_HEIGHT = 32
